module.exports = __webpack_public_path__ + "fonts/icomoon.493e606d.woff";